<div class="myPurchase-dialog-container">
    <div class="myPurchase-dialog-header">
        Add References
    </div>
    <div class="myPurchase-dialog-content">
        <app-selectable-table [data]="blanketPurchaseRecords" [columns]="blanketPurchaseColumns"
            [selection]="selectedData"></app-selectable-table>
    </div>
    <div class="myPurchase-dialog-actions">
        <div mat-dialog-actions>
            <app-button class="padBtn" name="Close" mat-dialog-close></app-button>
            <app-button class="padBtn actionBtn" type="flat-button" name="Submit" (click)="onSubmit()"></app-button>
        </div>
    </div>
</div>